import React from 'react';

/**
 * Multi Author logo mark.
 * Renders the logo image with an optional size override.
 * Falls back to a text wordmark if the image fails to load.
 */
export default function Logo({ style = {} }) {
  const size = 70;
  return (
    <img
      src="/logo192.png"
      alt="Multi Author"
      width={size}
      height={size}
      style={{ objectFit: 'contain', display: 'block', ...style }}
      onError={(e) => {
        e.target.style.display = 'none';
      }}
    />
  );
}
